module.exports = __webpack_public_path__ + "img/17861_S.8c38cffe.png";